import moment from "moment-timezone";

export default function toDateHuman(date) {
  if (date) {
    let fromNow = moment().format();
    return moment(date).from(fromNow);
  } else {
    return;
  }
}